import { Box, IconButton, Stack, Typography } from "@mui/material";
import ArrowBackRounded from "@mui/icons-material/ArrowBackRounded";
import { useNavigate } from "react-router-dom";

/**
 * Buying Power detail page — V2 round 5.
 *
 * Placeholder shell for now: just a back button and a title, so the
 * chevron next to "Buying power (excl. bots)" on the Accounts page
 * has somewhere to land. The full page (breakdown of excl-bots vs
 * total, bots reserving capital, margin rules, recent holds, etc.)
 * ships in a follow-up iteration.
 *
 * The back button uses `navigate(-1)` so whichever page pushed us
 * here — Accounts, or a future deep-link — is where the user returns
 * to. Kept self-contained (no TopAppBar dependency) because
 * MobileShellV2 only renders the top bar on /profile; this page
 * needs its own header to give users a way back on mobile.
 */
export function BuyingPowerPage() {
  const navigate = useNavigate();

  return (
    <Box sx={{ maxWidth: 680, mx: "auto", px: 2 }}>
      <Stack
        direction="row"
        alignItems="center"
        spacing={1}
        sx={{
          position: "sticky",
          top: 0,
          zIndex: (t) => t.zIndex.appBar,
          bgcolor: "background.default",
          mx: -2,
          px: 1,
          py: 1
        }}
      >
        <IconButton
          aria-label="Back"
          onClick={() => navigate(-1)}
          sx={{ color: "text.primary" }}
        >
          <ArrowBackRounded />
        </IconButton>
        <Typography variant="h6" sx={{ fontWeight: 700 }}>
          Buying Power
        </Typography>
      </Stack>
    </Box>
  );
}
